import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import "./App.css";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MyAppBar from "./AppComponents/MyAppBar";
import MyGrid from "./AppComponents/MyGrid";
import ProgressLine from "./AppComponents/ProgressLine";
import ArrowIcon from "@material-ui/icons/SwapHoriz";
import Login_Page from "./AppComponents/LoginPage";
import PageNotFound from "./AppComponents/PageNotFound";
import Game from "./game/Game";
import { BrowserRouter, Route, Link, Switch } from "react-router-dom";
import { LinearProgress } from "@material-ui/core";

//import NewLoginPage from "./AppComponents/LoginComponent/App";
//import KeyboardGame from "./game/KeyboardGame";

const Home = lazy(() => import("./AppComponents/MyGrid"));
//const LoginPage = lazy(() => import("./AppComponents/LoginPage"));
const LazyGame = lazy(() => import("./game/Game"));
const LazyKeyboardGame = lazy(() => import("./game/KeyboardGame"));

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={<LinearProgress />}>
          <Switch>
            <Route exact path={"/"} component={Login_Page} />
            <Route path={"/home"} component={Home} />
            <Route path={"/word-game"} component={LazyGame} />
            <Route path={"/typing-game"} component={LazyKeyboardGame} />
            <Route path={"/*"} component={PageNotFound} />
          </Switch>
        </Suspense>
        {/* <Switch>
          <Route exact path={"/"} component={Login_Page} />
          <Route path={"/new"} component={NewLoginPage} />
          <Route path={"/home"} component={MyGrid} />
          <Route path={"/word-game"} component={Game} />
          <Route path={"/typing-game"} component={KeyboardGame} />
          <Route path={"/*"} component={PageNotFound} />
        </Switch> */}
      </BrowserRouter>
    );
  }
}

export default App;

export const AppContext = React.createContext("appcontext");

//TODO
//window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
